import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { HttpRequestService } from './http-request.service';

@Injectable({
  providedIn: 'root'
})
export class ResolverService implements Resolve<any> {

  constructor(private authService: AuthService,
              private httpService: HttpRequestService) { }

  resolve(route: ActivatedRouteSnapshot) {
    const loggerUserDetails = this.authService.getLoggedUserDetails();
    const requestData = {
      'workFlowName'   : 'CoreAdminService',
      'processType'    : 'Screen',
      'workFlowParams' : JSON.stringify({
        'methodName'   : 'fetchConsoleTransactions',
        'strToken'     : loggerUserDetails.strToken,
        'strUserId'    : loggerUserDetails.USER_NAME
      })
    }
    
    return this.httpService.configRequestDataWithHeaders(requestData, 'post', '').subscribe(
      (response: any) => { 
        return response;
      });
  }


}
